import { API_ROUTES_FOR_AXIOS } from 'src/constants/ApiRoutes';
import { axiosInstance } from 'src/constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import { handleError } from 'src/utils/commonErrorUtils';

export interface CustomEventTrackingPayload {
  userId: string;
  orgId: string;
  eventName: string;
}

export const customEventTracking = async (
  body: CustomEventTrackingPayload,
): Promise<ApiResponse<string>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['customEventTracking']();
    const { data } = await axiosInstance.post(apiUrl, body);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
